/**
 * Cross-app handoff to the legacy (v1) client while v2 overview/dashboard
 * is still empty. Prefer this over SPA `/overview` routes so users never
 * land on a blank v2 page.
 */

const v1Base = () => String(import.meta.env.VITE_V1_BASE_URL || '').replace(/\/$/, '')

/**
 * Absolute v1 overview URL for the current shell.
 *
 * @param {{ group?: boolean }} [opts]
 * @returns {string}
 */
export function v1OverviewUrl({ group = false } = {}) {
  const base = v1Base()
  const path = group ? '/group/overview' : '/overview'
  return base ? `${base}${path}` : path
}

/**
 * Hard-navigate to v1 overview (full page load).
 * No-ops when `VITE_V1_BASE_URL` is unset to avoid looping on SPA `/overview`.
 *
 * @param {{ group?: boolean }} [opts]
 * @returns {boolean} true when navigation was started
 */
export function goToV1Overview({ group = false } = {}) {
  if (!v1Base()) {
    console.warn('[v1Navigation] VITE_V1_BASE_URL is not set — staying on v2')
    return false
  }
  window.location.assign(v1OverviewUrl({ group }))
  return true
}

/**
 * True when a v2 path is just an overview stub (should hand off to v1).
 *
 * @param {string} path
 * @returns {boolean}
 */
export function isV2OverviewPath(path) {
  return path === '/overview' || path === '/ryhma/overview'
}
